// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"24f85ca7dfe7843b","5405":"414c7efc01838865"}[chunkId] + ".css";
};